var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDoor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.5C10.5523 9.5 11 9.05229 11 8.5C11 7.94772 10.5523 7.5 10 7.5C9.44776 7.5 9.00004 7.94772 9.00004 8.5C9.00004 9.05229 9.44776 9.5 10 9.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 2V14C13 14.5515 12.5515 15 12 15H4.00004C3.44854 15 3.00004 14.5515 3.00004 14V2C3.00004 1.4485 3.44854 1 4.00004 1H12C12.5515 1 13 1.4485 13 2ZM4.00004 14H12V1.99925L4.00004 2V14Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 14V15H1.33337V14H14.6667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDoor);
export default __webpack_public_path__ + "static/media/ic-door.319be364ec51a4432ee46bfad402a92f.svg";
export { ForwardRef as ReactComponent };